import IconLL1 from "../components/Icons/IPR-v2/IconLL-1"
import IconLL2 from "../components/Icons/IPR-v2/IconLL-2"
import IconLL3 from "../components/Icons/IPR-v2/IconLL-3"
import IconLL4 from "../components/Icons/IPR-v2/IconLL-4"
import IconLL5 from "../components/Icons/IPR-v2/IconLL-5"
import IconLL6 from "../components/Icons/IPR-v2/IconLL-6"
import IconLL7 from "../components/Icons/IPR-v2/IconLL-7"
import IconLR1 from "../components/Icons/IPR-v2/IconLR-1"
import IconLR2 from "../components/Icons/IPR-v2/IconLR-2"
import IconLR3 from "../components/Icons/IPR-v2/IconLR-3"
import IconLR4 from "../components/Icons/IPR-v2/IconLR-4"
import IconLR5 from "../components/Icons/IPR-v2/IconLR-5"
import IconLR6 from "../components/Icons/IPR-v2/IconLR-6"
import IconLR7 from "../components/Icons/IPR-v2/IconLR-7"
import IconUL1 from "../components/Icons/IPR-v2/IconUL-1"
import IconUL2 from "../components/Icons/IPR-v2/IconUL-2"
import IconUL3 from "../components/Icons/IPR-v2/IconUL-3"
import IconUL4 from "../components/Icons/IPR-v2/IconUL-4"
import IconUL5 from "../components/Icons/IPR-v2/IconUL-5"
import IconUL6 from "../components/Icons/IPR-v2/IconUL-6"
import IconUL7 from "../components/Icons/IPR-v2/IconUL-7"
import IconUR1 from "../components/Icons/IPR-v2/IconUR-1"
import IconUR2 from "../components/Icons/IPR-v2/IconUR-2"
import IconUR3 from "../components/Icons/IPR-v2/IconUR-3"
import IconUR4 from "../components/Icons/IPR-v2/IconUR-4"
import IconUR5 from "../components/Icons/IPR-v2/IconUR-5"
import IconUR6 from "../components/Icons/IPR-v2/IconUR-6"
import IconUR7 from "../components/Icons/IPR-v2/IconUR-7"
import { EIPRToothMap, IIPRToothData } from "../types"

export const iprURToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.UR_1,
    isMissingTooth: false,
    icon: <IconUR1 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_2,
    isMissingTooth: false,
    icon: <IconUR2 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_3,
    isMissingTooth: false,
    icon: <IconUR3 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_4,
    isMissingTooth: false,
    icon: <IconUR4 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_5,
    isMissingTooth: false,
    icon: <IconUR5 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_6,
    isMissingTooth: false,
    icon: <IconUR6 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_7,
    isMissingTooth: false,
    icon: <IconUR7 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UR_8,
    isMissingTooth: false,
    icon: <IconUR7 />,
    point: [],
    data: [],
  },
]

export const iprULToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.UL_1,
    isMissingTooth: false,
    icon: <IconUL1 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_2,
    isMissingTooth: false,
    icon: <IconUL2 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_3,
    isMissingTooth: false,
    icon: <IconUL3 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_4,
    isMissingTooth: false,
    icon: <IconUL4 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_5,
    isMissingTooth: false,
    icon: <IconUL5 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_6,
    isMissingTooth: false,
    icon: <IconUL6 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_7,
    isMissingTooth: false,
    icon: <IconUL7 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_8,
    isMissingTooth: true,
    icon: <IconUL7 />,
    point: [],
    data: [],
  },
]

export const iprLRToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.LR_1,
    isMissingTooth: false,
    icon: <IconLR1 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_2,
    isMissingTooth: false,
    icon: <IconLR2 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_3,
    isMissingTooth: false,
    icon: <IconLR3 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_4,
    isMissingTooth: false,
    icon: <IconLR4 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_5,
    isMissingTooth: false,
    icon: <IconLR5 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_6,
    isMissingTooth: false,
    icon: <IconLR6 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_7,
    isMissingTooth: false,
    icon: <IconLR7 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LR_8,
    isMissingTooth: true,
    icon: <IconLR7 />,
    point: [],
    data: [],
  },
]

export const iprLLToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.LL_1,
    isMissingTooth: false,
    icon: <IconLL1 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LL_2,
    isMissingTooth: false,
    icon: <IconLL2 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LL_3,
    isMissingTooth: false,
    icon: <IconLL3 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LL_4,
    isMissingTooth: false,
    icon: <IconLL4 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LL_5,
    isMissingTooth: false,
    icon: <IconLL5 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.LL_6,
    isMissingTooth: false,
    icon: <IconLL6 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_7,
    isMissingTooth: false,
    icon: <IconLL7 />,
    point: [],
    data: [],
  },
  {
    id: EIPRToothMap.UL_8,
    isMissingTooth: true,
    icon: <IconLL7 />,
    point: [],
    data: [],
  },
]
